import EventBus from "../components/event-bus";
import { HTTP } from '../http-common';
//import moment from 'moment';

export const commonMixins = {

    data: () => ({
        currentEnvironment: false,
    }),
    mounted: function () {

        var self = this;
        if (process.env.NODE_ENV == 'production') {
            self.currentEnvironment = false;
        } else {
            self.currentEnvironment = true;
        }
        //check token if user came from rental
        /* var token = this.$route.query.token;
        if (token != undefined) {
            localStorage.setItem("tkn", token);
        } */

        /* if Acces Token is not exits redirect to login page. */
        const path = "/";
        if ((localStorage.getItem("tkn") == "" || localStorage.getItem("tkn") == null)
            && this.$route.path !== path) {
            self.$router.push("/");
        }
    },
    created() {
        /*console.log("mixin created");*/
    },
    beforeMount() {

    },
    watch: {
    },

    methods: {
        create_UUID: function () {
            var dt = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (dt + Math.random() * 16) % 16 | 0;
                dt = Math.floor(dt / 16);
                return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
            return uuid;
        },
        checkUUID: function (arr, uuid) {
            return arr.some(function (el) {
                return el.uuid === uuid;
            });
        },
        //make sentence first letter capital
        ucString(data) {
            var value = data.replace(/_/g, " ");
            var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                return letter.toUpperCase();
            });
            return upp;
        },
        utcToLocal(dateTime, format) {
            var self = this;
            var local = moment.utc(dateTime).local().format(format);
            return local;
        },
        showSAlert(message, type, callback) {
            this.$swal.fire(
                message,
                '',
                type
            );
            //callback("message");
        },
        catchHandler(err, callback) {
            var self = this;
            switch (err.response.status) {
                case 0:
                    this.showSAlert('Remote server can not be reachable', 'error', callback);
                case 400:
                    this.showSAlert(err.response.data.message, 'error', callback);
                    break;
                case 401:
                    /* localStorage.removeItem("user_obj");
                    localStorage.removeItem("tkn");
                    self.$router.push("/");
                    EventBus.$emit("showHeader", false); */
                    // let current_build = window.localStorage.getItem("build_version");
                    localStorage.clear();
                    // localStorage.setItem("build_version", current_build);
                    // window.location.href = process.env.SSO_ROOT_URL + "/login?redirect_url=" + process.env.FRONT_ROOT_URL + '&slug=' + process.env.PROJECT_SLUG;
                    window.location.href = process.env.SSO_ROOT_URL + "/logout?redirect_url=" + process.env.FRONT_ROOT_URL + '&slug=' + process.env.PROJECT_SLUG;
                    break;
                case 404:
                    this.showSAlert(err.response.data.message, 'error', callback);
                    break;
                case 409:
                    this.showSAlert(err.response.data.message, 'error', callback);
                    break;
            }
        },
        removeSpacesString(srting) {
            return srting.replace(/\s/g, '').toLowerCase();
        },
        stringTrim(string, length) {
            length = (typeof length !== 'undefined') ? length : 20;
            var string1 = (string.length > length) ? string.substring(0, length) + '...' : string;
            return string1;
        },
        showLoader() {
            $(".loading-container").show();
        },
        hideLoader() {
            $(".loading-container").hide();
        },
        /* accessAllowPage: function() {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            var role = 'guest';
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                var roleData = userJson["role"].split(" ");
                role = userJson["role"];
                if(roleData[1] && roleData[1] != '') {
                    role = roleData[1];
                }
            }

            if( (segments[1] == 'user' || segments[1] == 'customer' || segments[1] == 'archived') && (role == 'admin')) {
                self.cantAccessPage = true;
            } else {
                self.cantAccessPage = false;
            }
        }, */
        //getPermissions: function (callback) {
        getPermissions: function () {
            var self = this;
            var fields = {
            };
            var config = {
                headers: { Authorization: "Bearer " + localStorage.getItem("tkn") },
            };
            self.firstLoad = 1;
            //self.showLoader();
            HTTP.post("user-permission", '', config)
                .then(function (response) {
                    // if (response.data.code == '200') {
                        self.cantAccessPage = response.data.content;
                        self.isRequestComplete = true;
                        /* self.permissions = response.data.content;
                        EventBus.$emit("user-permissions", self.permissions); */
                    // }
                    // self.hideLoader();
                })
                .catch(function (error) {
                    // self.hideLoader();
                    if (typeof error.data !== 'undefined' &&
                        typeof error.data.content !== 'undefined') {
                        // your code here
                        self.cantAccessPage = error.data.content;
                    } else {
                        self.catchHandler(error, function () { });
                    }
                });
        }
    },
    computed: {
    }
};


// WEBPACK FOOTER //
// ./src/mixins/commonMixins.js